import { render } from "./LongtermSwitch.vue?vue&type=template&id=64667412"
import script from "./LongtermSwitch.vue?vue&type=script&lang=js"
export * from "./LongtermSwitch.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__